const environment = process.env;

export default environment;